<template>
  <v-card v-if="!loading" class="fill-height pa-4">
  <v-card-title>{{retailer.retailer}}</v-card-title>
    <v-card-text class="fill-height">
      <v-row>
        <v-col class="col-3">
          <pre>{{retailer}}</pre>
        </v-col>
        <v-col>
          <l-map :zoom="zoom" :center="center" v-if="markerLatLng">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker :lat-lng="markerLatLng">
              <l-icon :icon-size="[40, 40]" :icon-url="redIcon" :icon-anchor="[20, 40]" />
            </l-marker>
          </l-map>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import RetailerApi from "@/api/retailers";
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import moment from "moment";
import formatRetailerAddress from "@/utilities/formatRetailerAddress";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  data() {
    return {
      retailer: null,
      loading: true,
      loaded: true,
      selection: [],
      hour: moment().hours(),
      greenIcon:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
      redIcon:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
      mapOverlay: true,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: null,
      markerLatLng: null,
      imageUrl: process.env.VUE_APP_IMG_URL,
      iconSize: 40,
    };
  },
  created () {
    RetailerApi.loadRetailer(this.$router.currentRoute.params.id).then((results) => {
      this.retailer = results.data[0]
      this.center = [this.retailer.latitude, this.retailer.longitude],
      this.markerLatLng = [this.retailer.latitude, this.retailer.longitude],
      this.loading = false
    })
  },
  watch: {
    '$route.params.search': {
      handler: function(search) {
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onReady() {
      const bnds = this.$refs.features && this.$refs.features.mapObject.getBounds();
      this.$refs.map.fitBounds(bnds);
    },
    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    },
    getAddress(item) {
      return formatRetailerAddress(item);
    },
    close() {
      this.$emit("close");
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
dl {
  width: 150px;
  overflow: hidden;
  padding: 0;
  margin: 0;
}
dt {
  float: left;
  width: 25%;
  padding: 0;
  margin: 0;
  font-weight: 600;
}
dd {
  float: left;
  width: 75%;
  padding: 0;
  margin: 0;
}
</style>
